import * as React from 'react';

export type VisitConceptNodeKind = 'visit' | 'group' | 'form';

const LETTERS: Record<VisitConceptNodeKind, string> = {
  visit: 'V',
  group: 'G',
  form: 'F',
};

interface VisitConceptTypeBadgeProps {
  kind: VisitConceptNodeKind;
  /** Nombre del tipo para lectores de pantalla ("Visita", "Grupo", "Formulario"). */
  label: string;
}

/** Insignia cuadrada con la letra del tipo de nodo (guía: icono por tipo en el árbol). */
const VisitConceptTypeBadge: React.FC<VisitConceptTypeBadgeProps> = ({ kind, label }) => (
  <span className={`vct-badge vct-badge--${kind}`} role="img" aria-label={label} title={label} data-testid={`vct-badge-${kind}`}>
    {LETTERS[kind]}
  </span>
);

export default VisitConceptTypeBadge;
